import React, { FC, useCallback, useEffect } from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import Grid from 'components/UI/Grid';
import { useStores } from 'stores/hooks/hooks';
import Splitter from 'components/shared/Splitter';
import { WebPlot } from 'models/plot';
import FeaturesModels from './FeaturesModels';
import FeaturesSensors from './FeaturesSensors';

const Container = styled.div`
  height: 100%;
  width: 100%;
`;

// const Container = styled.div`
//   height: 100%;
//   width: 100%;
//   justify-content: flex-start;
//   overflow-y: auto;
// `;

const Features: FC = observer(() => {
  const { featuresStore, resellersStore } = useStores();
  const { selectedFeatures } = featuresStore;

  const getAllFeatures = useCallback(
    async (plots: WebPlot[]) => {
      await featuresStore.getAllFeatures(
        resellersStore.selectedGrowerId,
        plots,
      );
    },
    [featuresStore, resellersStore.selectedGrowerId],
  );

  useEffect(() => {
    if (resellersStore.resellerPlots.length) {
      getAllFeatures(resellersStore.resellerPlots);
    } else {
      featuresStore.resetFeatures();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resellersStore.resellerPlots, resellersStore.selectedGrowerId]);

  return (
    <Container>
      {!selectedFeatures.length && <FeaturesModels />}
      {!!selectedFeatures.length && (
        <Splitter>
          <div style={{ height: '100%' }}>
            <FeaturesModels />
          </div>
          <FeaturesSensors />
        </Splitter>
      )}
    </Container>
  );
});

export default Features;
